import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Label' })({
    line: {
        cursor: 'pointer',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 4
    },
    label: {
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '100%',
        flex: 2
    },
    score: {
        fontSize: 13,
        fontWeight: 600,
        lineHeight: '100%',
        flex: 1
    },
    _green: {
        color: '#05A569'
    },
    _orange: {
        color: '#EB8F01'
    },
    _red: {
        color: '#F5726A'
    },
    _gray: {
        color: '##E6E6E6'
    },
    chevron: {
        width: 16,
        height: 16,
        color: '#8E8E8E',
        transition: 'all 0.2s'
    },
    _rotated: {
        transform: 'rotate(180deg)'
    }
});
